import GetJSON from '../worker/getJSON.worker';
import { overrideParties, currentPartiesCode } from './mapParties';

const data = {
  portada: null,
  generales: null,
  historicGenerales: null,
  historicPortada: null,
  hierarchies: null,
};

function getGenerales() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (data.generales != null) {
        clearInterval(interval);
        resolve(data.generales);
      }
    }, 10);
  });
}

function getPortada() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (data.portada != null) {
        clearInterval(interval);
        resolve(data.portada);
      }
    }, 10);
  });
}

function getHistoricPortada() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (data.historicPortada != null) {
        clearInterval(interval);
        resolve(data.historicPortada);
      }
    }, 10);
  });
}

function getHistoricParties() {
  if (window.ac_historic_general_url) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (data.historicGenerales != null) {
          clearInterval(interval);
          resolve(data.historicGenerales.parties.map(overrideParties(currentPartiesCode)));
        }
      }, 10);
    });
  }
  return null;
}

function getParties() {
  if (window.ac_general_url) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (data.generales != null) {
          clearInterval(interval);
          resolve(data.generales.parties);
        }
      }, 10);
    });
  }
  return null;
}

function getVoting() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (data.generales != null) {
        clearInterval(interval);
        resolve(data.generales.voting);
      }
    }, 10);
  });
}

function getHistoricVoting() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (data.historicGenerales != null) {
        clearInterval(interval);
        resolve(data.historicGenerales.voting);
      }
    }, 10);
  });
}

function getHierarchies() {
  if (window.ac_hierarchies_url) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (data.hierarchies != null) {
          clearInterval(interval);
          resolve(data.hierarchies);
        }
      }, 10);
    });
  }
  return null;
}

function savePortada(e) {
  data.portada = JSON.parse(e.data);
}

function saveGenerales(e) {
  data.generales = JSON.parse(e.data);
}

function saveHistoricGenerales(e) {
  data.historicGenerales = JSON.parse(e.data);
}

function saveHistoricPortadas(e) {
  data.historicPortada = JSON.parse(e.data);
}

function saveHierarchies(e) {
  data.hierarchies = JSON.parse(e.data);
}

function init() {
  if (window.Worker) {
    if (window.ac_general_url) {
      const generalesWorker = new GetJSON();
      generalesWorker.postMessage(window.ac_general_url);
      generalesWorker.onmessage = saveGenerales;
    }

    if (window.ac_portadas_url) {
      const generalesWorker = new GetJSON();
      generalesWorker.postMessage(window.ac_portadas_url);
      generalesWorker.onmessage = savePortada;
    }
    if (window.ac_historic_general_url) {
      const generalesWorker = new GetJSON();
      generalesWorker.postMessage(window.ac_historic_general_url);
      generalesWorker.onmessage = saveHistoricGenerales;
    }
    if (window.ac_historic_portadas_url) {
      const generalesWorker = new GetJSON();
      generalesWorker.postMessage(window.ac_historic_portadas_url);
      generalesWorker.onmessage = saveHistoricPortadas;
    }
    if (window.ac_hierarchies_url) {
      const generalesWorker = new GetJSON();
      generalesWorker.postMessage(window.ac_hierarchies_url);
      generalesWorker.onmessage = saveHierarchies;
    }
  }
}

export default {
  init,
  getGenerales,
  getPortada,
  getParties,
  getVoting,
  getHistoricVoting,
  getHistoricParties,
  getHistoricPortada,
  getHierarchies,
};
